module.exports = __webpack_public_path__ + "img/triangle-25.b6cd8987.gif";